import React from 'react'
import TableRow from './TableRow'

const TableBody = ({
  selectedItems,
  customerColumns,
  selectedColumn,
  selectedColumnIds,
  selectedRowIndexes,
  handleRowSelection,
  distributionManager,
  getStickyLeft,
  buyerLeft,
  showTooltip,
  setShowTooltip,
  handleFixedCellChange,
  dropTargetId,
  isAtEnd,
  handleRowDragStart,
  handleRowDragEnd,
  handleRowDragOver,
  handleRowDrop,
  draggedRowIdx,
  draggedRowKey,
  dropTargetRowIdx,

  handleDragOver,
  handleDrop,
  hiddenRowKeys,
  onUnhideItem,
  handleRowContextMenu,
  gradeOptions,
  sizeOptions,
  rowReorderDisabled = false,
  isReadOnly = false
}) => {
  const rowKeys = selectedItems.map(
    (item) => `${item.hinmeiCode}::${item.niukabango}`
  )
  const visibleRows = []

  selectedItems.forEach((item, rowIdx) => {
    const rowKey = rowKeys[rowIdx]
    if (!hiddenRowKeys.has(rowKey)) {
      let hiddenBefore = []
      for (let i = rowIdx - 1; i >= 0; i--) {
        const prevKey = rowKeys[i]
        if (hiddenRowKeys.has(prevKey)) {
          hiddenBefore.push(prevKey)
        } else {
          break
        }
      }

      let hiddenAfter = []
      for (let i = rowIdx + 1; i < selectedItems.length; i++) {
        const nextKey = rowKeys[i]
        if (hiddenRowKeys.has(nextKey)) {
          hiddenAfter.push(nextKey)
        } else {
          break
        }
      }

      visibleRows.push({
        item,
        rowIdx,
        hiddenBefore,
        hiddenAfter
      })
    }
  })

  return (
    <tbody
      onDragOver={(e) => {
        if (isReadOnly) return
        handleDragOver(e, null)
        if (!rowReorderDisabled) handleRowDragOver(e, null)
      }}
      onDrop={(e) => {
        if (isReadOnly) return
        handleDrop(e, null)
        if (!rowReorderDisabled) handleRowDrop(e, null)
      }}
    >
      {visibleRows.map(
        ({ item, rowIdx, hiddenBefore, hiddenAfter }, visibleIdx) => (
          <TableRow
            key={`${item.hinmeiCode}-${item.niukabango}-${rowIdx}`}
            item={item}
            parentItem={item._parentItem || item}
            priceId={item._priceId}
            rowIdx={rowIdx}
            isLast={visibleIdx === visibleRows.length - 1}
            customerColumns={customerColumns}
            selectedColumn={selectedColumn}
            selectedColumnIds={selectedColumnIds}
            selectedRowIndexes={selectedRowIndexes}
            handleRowSelection={handleRowSelection}
            distributionManager={distributionManager}
            getStickyLeft={getStickyLeft}
            buyerLeft={buyerLeft}
            showTooltip={showTooltip}
            setShowTooltip={setShowTooltip}
            handleFixedCellChange={handleFixedCellChange}
            dropTargetId={dropTargetId}
            isAtEnd={isAtEnd}
            handleRowDragStart={handleRowDragStart}
            handleRowDragEnd={handleRowDragEnd}
            handleRowDragOver={handleRowDragOver}
            handleRowDrop={handleRowDrop}
            draggedRowIdx={draggedRowIdx}
            draggedRowKey={draggedRowKey}
            dropTargetRowIdx={dropTargetRowIdx}

            handleDrop={handleDrop}
            hiddenBefore={hiddenBefore}
            hiddenAfter={hiddenAfter}
            onUnhide={(key) => onUnhideItem('row', key)}
            handleRowContextMenu={handleRowContextMenu}
            gradeOptions={gradeOptions}
            sizeOptions={sizeOptions}
            rowReorderDisabled={rowReorderDisabled}
            isReadOnly={isReadOnly}
          />
        )
      )}
    </tbody>
  )
}

export default TableBody
